@if (appVersion) {
    <div class="version">
        <span>Version : </span> <span class="number">{{appVersion}}</span> 
    </div>
}